import React from "react";

import { useGranite } from "@redux/modules/value/translations/translations.provider";

import { Button } from "@components/General/Button/button.component";

type ClearSelectedFacetsComponentProps = {
    onClear: () => void;
};

const ClearSelectedFacetsComponent = ({
    onClear,
}: ClearSelectedFacetsComponentProps) => {
    const { t } = useGranite();

    return (
        <Button
            className="mb-2 bg-transparent text-primary"
            type="button"
            color="primary"
            size="sm"
            outline={true}
            onClick={onClear}
        >
            {t("search.selectedRefinements.clear")}
        </Button>
    );
};

export { ClearSelectedFacetsComponent };
